<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-供应商-添加供应商
  -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--基础设置-->
      <Basic :form="form" :positionList="positionList"></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import AdApi from '@/api/ad.js';
import Basic from './part/Basic.vue';
export default {
  components: {
    /*基础设置*/
    Basic,
  },
  data() {
    return {
      /*表单对象*/
      form: {
        image_id: 0,
        /*名称*/
        name: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
       
        /*默认排序*/
        sort: 100,
      },
      positionList: [
        {value:'supply-top',label:'门店产品列表-顶部'},
        {value:'supply-bottom',label:'门店产品列表-底部'}
      ],
       app_id:0,
       is_edit:false,
      /*是否正在加载*/
      loading: false
    };
  },
  created() {
   
  },
  methods: {
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form;
          delete params.tableData;
          self.loading = true;
          console.log(params);
          AdApi.addAd(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/add.vue